<!-- Different substep -->
<div [ngSwitch]="onboardingSubStep">
    <app-step1-company-registration *ngSwitchCase="1" [data]="companyDetailsForm.companyRegistration"
        (next)="onNextClick()" (prev)="onPrevClick()"></app-step1-company-registration>
    <app-step2-license-details *ngSwitchCase="2" [data]="companyDetailsForm.licenseDetails" (next)="onNextClick()" (prev)="onPrevClick()"></app-step2-license-details>
    <app-step3-company-information *ngSwitchCase="3"
        [data]="companyDetailsForm.companyInformation" (next)="onNextClick()" (prev)="onPrevClick()"></app-step3-company-information>
</div>